export class CadBagFactory {
  constructor(instance) {
    this.instance = instance;
  }

  getBags(filter) {
    return this.instance.get('/v1/cad-bags/', {
      params: filter || null,
    });
  }

  getBag(filter, id) {
    return this.instance.get(`/v1/cad-bags/${id}`, {
      params: filter || null,
    });
  }

  addBag(data) {
    return this.instance.post(`/v1/cad-bags/`, data);
  }

  editBag(id, data) {
    return this.instance.put(`/v1/cad-bags/${id}`, data);
  }

  deleteBag(id) {
    return this.instance.delete(`/v1/cad-bags/${id}`);
  }
}

export default (...params) => new CadBagFactory(...params);
